import React from "react";
import { Box, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const Banner = ({
  message,
  actionMessage,
  actionCallback,
  isLoading,
  message2,
  actionMessage2,
  backgroundColor,
  closable = false,
  onClose = () => {},
}) => {
  return (
    <Box
      style={{
        background: backgroundColor || theme.palette.common.blue,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        columnGap: "4px",
        flexWrap: "wrap",
        padding: "8px",
      }}
    >
      <Box>{message}</Box>
      {actionMessage && (
        <Box>
          <Button
            variant="textUnderline"
            onClick={actionCallback}
            disabled={isLoading}
            size="small"
            sx={{ padding: "0", minHeight: "unset", lineHeight: 1, fontFamily: "Segoe UI Semibold, system-ui, sans-serif" }}
          >
            {actionMessage}
          </Button>
        </Box>
      )}
      {message2 && <Box>{message2}</Box>}
      {actionMessage2 && (
        <Box>
          <Button
            variant="textUnderline"
            onClick={actionCallback}
            disabled={isLoading}
            size="small"
            style={{ padding: "0", minHeight: "unset", lineHeight: 1 }}
          >
            {actionMessage2}
          </Button>
        </Box>
      )}
      {closable && (
        <IconButton
          size="small"
          aria-label="close"
          onClick={onClose}
          style={{
            marginLeft: "auto",
            color: "white",
          }}
        >
          <CloseIcon fontSize="medium" />
        </IconButton>
      )}
    </Box>
  );
};

export default Banner;
